import { UnauthenticatedEmittedEvent } from '../types';

/** @todo is there ever a case where we don't want to send this event (bad "unauthentication") */
export function notifyUnauthenticated(): UnauthenticatedEmittedEvent {
  // no need to do checks since we will send same event no matter what
  return { type: 'EMIT_UNAUTHENTICATED' };
}

export default notifyUnauthenticated;
